var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height",staticStyle:{"overflow-y":"auto"}},[_c('app-manage-detail-status-options',{attrs:{"user-info":_vm.userInfo,"workflow-data":_vm.workflowInfo,"local-data":_vm.localData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }